import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  pictureMap: { height: '60vh', width: '100%' },
}));

export default styles;
